import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    isWS:true
  },
  getters:{ 
    getWSStatus:state=>state.isWS,
  },
  mutations: {
    setWS(state,s){ state.isWS=s;}
  },
  actions: {

  }
})
